import { Toaster } from "@/components/ui/sonner";
import { GlobalLoadingBar } from "@/components/GlobalLoadingBar";
import { GlobalForegroundLoadingBridge } from "@/components/GlobalForegroundLoadingBridge";

/**
 * Clarity One host shell: global loading may observe customer queries, but staff
 * authentication (staff identity queries, marketing guards, daylight staff context) is not mounted.
 */
export default function ClarityOneAppShell({ children }: { children: React.ReactNode }) {
  return (
    <>
      <GlobalForegroundLoadingBridge />
      <GlobalLoadingBar includeStaffAuth={false} />
      <Toaster />
      {children}
    </>
  );
}
